import { useContext, useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive'
import { Audiences } from './Audiences';

import { LeadDetails, Leads } from './leads';
import { Actions } from './Actions';
import AppContext from '_context/AppContext';
import { useOrientation } from '@uidotdev/usehooks';

export {
    Dashboard
}

function Dashboard() {
    const { user: authUser } = useSelector(x => x.auth);
    const { selectedLead, setSelectedLead } = useContext(AppContext);
    const [selectedAudience, setSelectedAudience] = useState(null);
    const [showAudiencesSection, setShowAudiencesSection] = useState(true);
    const [showLeadsSection, setShowLeadsSection] = useState(true);
    const [refreshAudiences, setRefreshAudiences] = useState(0); // Added state for refreshing audiences
    const orientation = useOrientation();

    // Check if the device is a tablet
    const isTablet = useMediaQuery({ minWidth: 950, maxWidth: 1200 });
    const isMobile = useMediaQuery({ maxWidth: 950 })

    // Check if the device is in landscape mode
    const isLandscape = useMediaQuery({ orientation: 'landscape' });

    // Combine both checks
    const allInOneColumns = (isTablet && !isLandscape) || isMobile;
    
    useEffect(() => {
        if (selectedLead) {
            if (allInOneColumns) {
                setShowAudiencesSection(false);
                setShowLeadsSection(false);
            } else {
                setShowAudiencesSection(true);
                setShowLeadsSection(true);
            }
        } else {
            if (selectedAudience) {
                setShowLeadsSection(true);
                if (allInOneColumns) {
                    setShowAudiencesSection(false);
                } else {
                    setShowAudiencesSection(true);
                }
            } else {
                setShowAudiencesSection(true);
                if (allInOneColumns) {
                    setShowLeadsSection(false);
                } else {
                    setShowLeadsSection(true);
                }
            }
        }
    }, [allInOneColumns])

    useEffect(() => {
        if (selectedLead) {
            if (allInOneColumns) {
                setShowAudiencesSection(false);
                setShowLeadsSection(false);
            } else {
                setShowAudiencesSection(true);
                setShowLeadsSection(true);
            }
        }
    }, [selectedLead])

    useEffect(() => {
        return function() {
            setSelectedLead(null)
        }
    }, []);

    const handleAudienceClicked = (audience) => {
        setSelectedAudience(audience);
        setSelectedLead(null)
        if (allInOneColumns) {
            setShowAudiencesSection(false);
            setShowLeadsSection(true);
        }
    }

    const handleLeadsBackClicked = () => {
        if (allInOneColumns) {
            setShowAudiencesSection(true);
            setShowLeadsSection(false);
        } else {
            setShowLeadsSection(true);
        }
    }

    const handleLeadDetailsBackClicked = () => {
        setSelectedLead(null);
        if (allInOneColumns) {
            if (selectedAudience) {
                setShowLeadsSection(true);
            } else {
                setShowAudiencesSection(true);
                setShowLeadsSection(false);
            }
        }
    }

    // New callback function to refresh audiences
    const handleLeadSaved = useCallback(() => {
        // Increment the refresh counter to trigger a refresh of the Audiences component
        setRefreshAudiences(prev => prev + 1);
    }, []);

    return (
        <>
            <Actions/>
            <div className="row mt-3">
                {showAudiencesSection === true ?
                    <>
                        <div className='col-lg-4-30 shadow-right' >
                            <Audiences 
                                handleAudienceClicked={handleAudienceClicked} 
                                refreshTrigger={refreshAudiences} // Pass this prop to Audiences
                            />
                        </div>
                        <div className='dashboard-column-divider' ></div>
                    </>
                : null}
                {showLeadsSection === true ?
                    <>
                        <div className='col-lg-4-30 shadow-right'>
                            <Leads 
                                audience={selectedAudience} 
                                showLeadsSection={showLeadsSection} 
                                handleClicked={setSelectedLead}
                                handleBackClick={handleLeadsBackClicked}
                                onLeadSaved={handleLeadSaved} // Pass this new prop to Leads
                            />
                        </div>
                        <div className='dashboard-column-divider'></div>
                    </>
                : null}
                {selectedLead &&
                    <div className='col-lg-4-30 shadow-right'>
                        <LeadDetails
                            lead={selectedLead}
                            onLeadUpdated={handleLeadSaved} // Pass this new prop to Leads
                            handleBackClick={handleLeadDetailsBackClicked}
                        />
                    </div>
                }
            </div>
        </>
    )
}